export const repertoire = [
  {
    title: 'Old Town Road (feat. Billy Ray Cyrus)',
    artist: 'Lil Nas X',
    tags: ['Hip-Hop/Rap', 'Party'],
  },
  {
    title: 'Mr. Brightside',
    artist: 'The Killers',
    tags: ['Rock', 'Indie', 'Party'],
  },
  {
    title: 'Ich will nur dass du weißt',
    artist: 'SDP',
    tags: ['Deutschsprachig', 'Pop'],
  },
  {
    title: 'Wonderwall',
    artist: 'Oasis',
    tags: ['Rock', 'Indie'],
  },
  {
    title: 'Follow You',
    artist: 'Bring Me The Horizon',
    tags: ['Rock', 'Alternative'],
  },
  {
    title: 'Chasing Cars',
    artist: 'Snow Patrol',
    tags: ['Rock', 'Ballade'],
  },
  {
    title: 'Jumper',
    artist: 'Third Eye Blind',
    tags: ['Rock', 'Alternative'],
  },
  {
    title: 'bellyache',
    artist: 'Billie Eilish',
    tags: ['Alternative', 'Pop'],
  },
  {
    title: 'River',
    artist: 'Bishop Briggs',
    tags: ['Alternative', 'Rock'],
  },
  {
    title: 'California King Bed',
    artist: 'Rihanna',
    tags: ['Pop', 'Ballade'],
  },
]

export const allTags = Array.from(
  new Set(repertoire.flatMap((song) => song.tags)),
).sort()
